import { useContext } from 'react';
import RecipientForm from '../../../ui-components/recipient-form';
import { giftcardState } from '../client-state/giftcard-state-context';
import { recipientReducerActionTypes } from '../../../redusers/recipient-reducer';
import { isSummaryOpenActionTypes } from '../../../redusers/is-summary-open-reducer';

const RecipientFormWithData = () => {
  const { state, dispatch } = useContext(giftcardState);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: recipientReducerActionTypes.UPDATE_NAME,
      payload: event.target.value,
    });
  };

  return (
    <RecipientForm
      value={state.recipient.name}
      onChange={handleChange}
      onSubmit={() =>
        dispatch({ type: isSummaryOpenActionTypes.SET_IS_OPEN, payload: true })
      }
      mobileButton={true}
    />
  );
};

export default RecipientFormWithData;
